module.exports = __webpack_public_path__ + "img/bg1.ae584a0a.png";